import { render, staticRenderFns } from "./v-sidebar-language.vue?vue&type=template&id=70f43dc4&scoped=true&"
import script from "./v-sidebar-language.vue?vue&type=script&lang=js&"
export * from "./v-sidebar-language.vue?vue&type=script&lang=js&"
import style0 from "./v-sidebar-language.vue?vue&type=style&index=0&id=70f43dc4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f43dc4",
  null
  
)

export default component.exports